import { motion } from "framer-motion";
import {
  Factory,
  HeartPulse,
  GraduationCap,
  Sprout,
  LandPlot,
  Zap,
} from "lucide-react";

const items = [
  {
    icon: Factory,
    title: "Manufacturing",
    desc: "Predictive Maintenance, Production Monitoring, OEE intelligence.",
  },
  {
    icon: HeartPulse,
    title: "Healthcare",
    desc: "Remote Patient Monitoring, Smart Healthcare workflows, Clinical AI.",
  },
  {
    icon: GraduationCap,
    title: "Education",
    desc: "Smart Campuses, AI Learning Platforms, Connected classrooms.",
  },
  {
    icon: Sprout,
    title: "Agriculture",
    desc: "Precision Farming, Environmental Monitoring, Yield prediction.",
  },
  {
    icon: LandPlot,
    title: "Smart Cities",
    desc: "Traffic Monitoring, Waste Management, Public safety AI.",
  },
  {
    icon: Zap,
    title: "Energy",
    desc: "Energy Optimization, Utility Monitoring, Grid intelligence.",
  },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="py-24 sm:py-32 relative">
      <div className="absolute inset-0 -z-10 grid-bg opacity-30" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-7"
          >
            <p className="text-xs uppercase tracking-[0.3em] text-cyan-400 font-semibold mb-3">
              Industries We Serve
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
              Solutions tailored for
              <span className="gradient-text-vivid"> mission-critical industries</span>
            </h2>
          </motion.div>
          <p className="lg:col-span-5 text-slate-300 text-base sm:text-lg">
            We embed deep domain knowledge into every deployment — so your AI &amp; IoT investments
            translate into measurable business outcomes from day one.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`industry-card-${it.title.toLowerCase()}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="card-hover group relative bg-[#131C2F] border border-white/10 rounded-2xl p-6 lg:p-7 overflow-hidden"
              >
                <div className="absolute -bottom-12 -right-12 w-44 h-44 rounded-full bg-gradient-to-tr from-blue-500/10 to-cyan-400/10 blur-2xl group-hover:from-blue-500/20 group-hover:to-cyan-400/20 transition" />
                <div className="relative">
                  <div className="w-11 h-11 rounded-xl bg-cyan-500/10 border border-cyan-500/20 grid place-items-center">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <h3 className="mt-5 font-heading text-xl font-semibold">{it.title}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{it.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
